import { inject } from '@angular/core';
import { IHttpOptions } from '@partners/http';
import { isEmptyObject } from '@partners/utils';
import { CatalogService } from '../services/catalog.service';

export const metadataCatalogGuard = async (options: IHttpOptions = {}): Promise<boolean> => {
  const catalogService = inject(CatalogService);
  const metadataCatalog = await catalogService.loadMetadata(options);
  return !isEmptyObject(metadataCatalog);
};
